module.exports = __webpack_public_path__ + "img/69ne.03eb53b3.svg";